export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12008.5d4db57b.jpg";